// extracted by mini-css-extract-plugin
export default {"heading":"uu-z","corrected":"vu-z","redirectVerbiageContainer":"wu-z","redirectVerbiageText":"xu-z"};